<template>       
    <div class="clearfix rounded pb-5 mx-auto">    
        <div class="row pb-2 mb-2" v-if="flg == 0">

            <div class="col-md-7">

                <div class="leave-attendance-front-container">
                <div class="attendance-log">
          
                <v-calendar is-expanded :masks="masks" :attributes="attributes" :first-day-of-week="first_day_of_week" ref="trzcalendar"
                    class='v-calendar all-leaves' @update:to-page="monthDetails" > 
                
                    <template slot="day-content" class='vc-w-full vc-relative' slot-scope='{day, dayEvents, attributes, attributesMap , popover}'>
                        <template v-if="this_month_holidays[day.id] == undefined">
                            <template v-if="weekly_holidays.includes(day.weekday)">
                                <div class="vc-day-content" :style="{'background-color':weekend_color_code,'color':'#fff'}">
                                    <div class="flex flex-column h-100 overflow-hidden">
                                        {{day.day}}
                                    </div>
                                </div> 
                            </template>
                            <template v-else>
                                <div class="vc-day-content">
                                    <div class="flex flex-column h-100 overflow-hidden">
                                    
                                        {{day.day}}
                                    </div>
                                </div> 
                            </template>
                        </template>
                               
                        <template v-else>
                            
                            <template>
                                <div class='vc-day-content'  :style="{'background-color':holiday_color_code}">
                                    <div :title="this_month_holidays[day.id].title">                               
                                        <div class="flex flex-column overflow-hidden" >
                                            {{day.day}}
                                        </div>
                                    </div>
                        
                                </div>
                            </template>
                        </template>
                        
                        
                        
                    </template>

                </v-calendar>
                </div>
                </div>
            </div>
            <div class="col-md-5 row px-0 log-data-mobile">           
            
                <div class="col-sm-12 px-0">
                    <div class="stats-info-wrapper ">
                        <div class="stats-info">
                            <div class="text">Approved Leave Today</div> 
                            <div class="value">{{approved_leaves_today}}</div>
                        </div>
                        <div class="stats-info">
                            <div class="text">Pending Leave Request</div>
                            <div class="value">{{pending_leaves_fiscal_year}}</div>
                        </div>
                    </div> 
                </div>
                <div class="attendance-log">
                    <div class="stats-info-wrapper legend mt-3">                          
                        <div class="row col-sm-12 trz_borders px-4 mb-0">
                            <div class="col-sm-4 py-3"><div class="mark current"></div><div class="text">Today</div></div>
                
                            <div class="col-sm-4 py-3"><div class="mark holiday" :style="{'background-color':holiday_color_code}"></div><div class="text">Holiday</div></div>
                            <div class="col-sm-4 py-3"><div class="mark holiday" :style="{'background-color':weekend_color_code}"></div><div class="text">Weekend</div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="all-leave-wrapper py-3 mt-4">
            <div class="leave-list-wrapper row pt-1">
                <div class="col-sm-12 company-form-box-title applied leave-log-mobile">Leave Log <span class="leave-status ml-2"><i class="fa fa-circle mr-1"></i>Pending</span></div> 
                <div class="col-sm-12">
                    <leaves-list-applied-front :flg="flg"  :key="list_key" :manager="true"  v-on:childToParent="listReturn"></leaves-list-applied-front>
                </div>
                </div>
            <div class="leave-list-wrapper row pt-1">
                <div class="col-sm-12 company-form-box-title approved leave-log-mobile">Leave Log  <span class="leave-status ml-2"><i class="fa fa-circle mr-1"></i>Approved</span></div> 
                <div class="col-sm-12">
                    <leaves-list-approved-front :flg="flg"  :key="list_key_1" :manager="true"   v-on:childToParent="listReturn"></leaves-list-approved-front>
                </div>
                </div>
            <div class="leave-list-wrapper row pt-1">
                <div class="col-sm-12 company-form-box-title  declined leave-log-mobile">Leave Log <span class="leave-status ml-2"><i class="fa fa-circle mr-1"></i>Declined</span></div> 
                <div class="col-sm-12">
                    <leaves-list-declined-front :flg="flg"  :key="list_key_2" :manager="true"  v-on:childToParent="listReturn"></leaves-list-declined-front>
                </div>
                </div>
        </div>

        
        </div> 
</template>
<script>
    import moment from 'moment'
    export default{
        
        mounted() {
            if(this.check_ce == 1)
            {                
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;
                
            }   
        },
        props: [ 'flg'],
        components: {},
        data(){ 
            /** Sohel Code Starts Here */
            let sortOrders = {};
            let columns = [
                            {label: 'Employee', name: 'employee_name' },
                            {label: 'Job Position', name: 'employee_code' },
                            {label: 'Department', name: 'department' },
                            {label: 'Leave Type', name: 'leave_type'},
                            {label: 'From', name: 'from'},
                            {label: 'To', name: 'to'},
                            {label: 'No of Days', name: 'number_of_days'},
                            {label: 'Reason', name: 'reason'},
                            {label: 'Status', name: 'status'},
                            {label: 'Updated By', name: 'updated_by'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            /** Sohel Code Ends Here */
            
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            
            const minDate = new Date(today);
            minDate.setMonth(minDate.getMonth());
            minDate.setDate(minDate.getDate());
            const startdate = minDate;
            var startDate = '';
            var endDate = '';
            //var today = new Date();
            if ((today.getMonth() + 1) <= 6) 
            {                    
                startDate = (today.getFullYear() - 1) + '-07-1';
                endDate = (today.getFullYear()) + '-06-30';
            } 
            else 
            {
                startDate = (today.getFullYear()) + '-07-1';
                endDate = (today.getFullYear() + 1) + '-06-30';
            }

            return {  
                depertments:[],
                search_by_id:{department_id:0,jobposition_id:0, leave_type_id:0 , flg_status:0},
                startDate : startDate,
                endDate : endDate,
                min: minDate,
                day_one: moment(String(startdate)).format('YYYY-MM-DD') , 
                day_two: moment(String(startdate)).format('YYYY-MM-DD') ,
                week_holidays : [6],
                all_week_holidays : [6],
                week_start_day : 7,
                holidays_date_arr : [], 
                leavetypes: [],
                flg_status : [
                            { text: 'Applied', value: '0' },
                            { text: 'Approved', value: '1' },
                            { text: 'Declined', value: '2' },
                        ],
                
                /** Sohel Code Starts Here */
                columns: columns,
                sortKey: 'employee_name',
                sortOrders: sortOrders,                
                /** Sohel Code Ends Here */
                
                leaves:[],

                showoverlay:false,
                showoverlay_list:false,
                movenext : false,

                errormsg:[],
                fdata: {  },
                
                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                ce : true,
                employee_id : 0,
                list_key:0,
                list_key_1:0,
                list_key_2:0,

                approved_leaves_today : 0,
                pending_leaves_today : 0,
                pending_leaves_fiscal_year : 0,

                
                tmp_leave_type_id : 0,
                tmp_flg_status : 0,
                tmp_from : '',
                tmp_to : '',


                start_date: null,
                end_date: null,
                lv : [],
                this_month_holidays : [],
                this_month : 1,
                this_year : 2020,
                weekly_holidays : [6],
                first_day_of_week : 7,
                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,
                weekend_color_code : '#aaaaaa',
                holiday_color_code : '#aaaaaa',
                

                masks : 
                    {
                        title: 'MMMM YYYY',
                        weekdays: 'WW',
                        navMonths: 'MMM',
                        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                        dayPopover: 'WWW, MMM D, YYYY',
                        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    },

                attributes: [
                        {
                            key: 'today',
                            dates: new Date(),
                        }
                    ],
            }
        },
        methods:{  
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },     
            listReturn:function(data)
            {
                console.log("Emitted");
                this.list_key = this.list_key + 1;
                this.list_key_1 = this.list_key_1 + 1;
                this.list_key_2 = this.list_key_2 + 1;
            },  
            monthDetails: function(x)
            {              
                let currentObj = this;
                let year = x['year'];
                let month = x['month'];
                let st_date = new Date(year , month - 1 , 1);
                let en_date = new Date(year , month , 0);

                this.this_month = x['month'];
                this.this_year = x['year'];

                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');
                
                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/front/holidays/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){
                    
                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10) + 1;});
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;
                    
                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                    this.weekend_color_code = response.data.report.weekend_color_code;
                    this.holiday_color_code = response.data.report.holiday_color_code;
                    

                    console.log('weekly_holidays');
                    console.log(this.weekly_holidays);

                    console.log('weekend_color_code');
                    console.log(this.weekend_color_code);

                    console.log('this_month_holidays');
                    console.log(this.this_month_holidays);

                    console.log('holiday_color_code');
                    console.log(this.holiday_color_code); 
                    
                        
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            }, 
            importLeaves: function()
            {
                this.$bvModal.show('bv-modal-import-leave');
            },
            uploadLeaveFile:function(event) 
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;                
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.$api_url+'/front/employee/leave/import/import', data , config).
                    then(function (response){

                        
                         
                        this.$bvToast.toast('Successfully Imported', {
                                            title: `Success`,
                                            variant: 'info',
                                            solid: true
                                        });                        
                    
                        this.showoverlay = false; 
                        this.$bvModal.hide('bv-modal-import-leave');

                        this.getLeaves();
                        
                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                    this.showoverlay = false; 
            },  
            getLeaves: function()
            {
                if(!this.checkNet()) return false;
                
                if(this.flg == 0)
                    this.employee_id = 0;
                
                
                this.$bvModal.hide('bv-modal-leave-details');
                let currentObj = this;
                axios.get(this.$api_url+'/front/employees/leaves/fiscalyear?flg=' + this.flg , {
                    params: {
                        search_by_id: this.search_by_id
                    }
                }).then(function(response){
                    this.leaves = response.data.leaves;
                    this.employee_id = response.data.employee_id;

                    this.approved_leaves_today = response.data.approved_leaves_today;                    
                    //this.pending_leaves_today = response.data.pending_leaves_today;
                    this.pending_leaves_fiscal_year = response.data.pending_leaves_today;

                    this.$bvModal.hide('bv-modal-edit-leave');
                    this.$bvModal.hide('bv-modal-add-leave');
                    //console.log(this.leaves);

                    
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
             
            getApprovePendingLeavesToday: function()
            {
                if(!this.checkNet()) return false;
                
                let currentObj = this;
                axios.get(this.$api_url+'/front/approve-pending/leaves/today' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.approved_leaves_today = response.data.approved_leaves_today;
                    this.pending_leaves_today = response.data.pending_leaves_today;
                    this.pending_leaves_fiscal_year = response.data.pending_leaves_fiscal_year;
                    
                    
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            setEmployee: function(x)
            {
                this.employee_id = x.employee_id;
            },
            addNew()
            {
                if(this.flg == 0)
                    this.employee_id = 0;
                
                this.$bvModal.show('bv-modal-add-leave');
            },

            //editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)
            editLeave: function(employee_id , leave_type_id , flg_status , from , to)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.employee_id = 0;
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                axios.post(this.$api_url+'/front/employee/setemployee', formData)
                    .then(function (response) 
                    {    
                        this.employee_id = employee_id;

                        this.tmp_leave_type_id = leave_type_id;
                        this.tmp_flg_status = flg_status;
                        this.tmp_from = from;
                        this.tmp_to = to;

                        this.$bvModal.show('bv-modal-edit-leave');
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                
            },
            updateLeave: function(employee_id , leave_type_id , flg_status , from , to , status)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.employee_id = 0;
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                formData.append('leave_type_id' , leave_type_id);
                formData.append('flg_status' , flg_status);
                formData.append('from' , from);
                formData.append('to' , to);
                formData.append('status' , status);

                axios.post(this.$api_url+'/front/employee/leaves/status', formData)
                    .then(function (response) 
                    {    
                        this.getLeaves();
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                
            },
            deleteLeave: function(employee_id , leave_type_id , flg_status , from , to)
            {
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                formData.append('leave_type_id' , leave_type_id);
                formData.append('from' , from);
                formData.append('to' , to);
                formData.append('flg_status' , flg_status);

                

                axios.post(this.$api_url+'/front/leave/delete/range', formData)
                    .then(function (response) 
                    {    
                        this.$bvToast.toast('Deleted!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });
                        
                    
                        this.getLeaves();
                        //this.getApprovePendingLeavesToday();
                    
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },



            getDepertments: function(){
              axios.get(this.$api_url+'/front/department/list')
              .then(function (response) {
                 this.depertments = response.data;
              }.bind(this));
         
            },

            dateDisabled(ymd, date) {
                const x = moment(String(date)).format('YYYY-MM-DD');
                const weekday = date.getDay();
                const day = date.getDate();                
                return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
            },
            updateToDate:function()
            {
                if(this.fake == 1)return;
                this.day_two = this.day_one;
                this.min = this.day_one;
            },
            checkValidDate:function()
            {
                if(moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
                    this.updateToDate();
            },
            
            getDisabledDates:function() 
            {   
                axios.get(this.$api_url+'/front/holidays/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)                    {
                        this.all_week_holidays = response.data.report.week_holidays;
                        this.week_holidays = response.data.report.week_holidays.split(',');
                        this.week_start_day =  response.data.report.week_start_day;
                        this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
                    }                          
                }.bind(this));
            },
            getLeaveTypes: function()
            {
                if(!this.checkNet()) return false;                
                axios.get(this.$api_url+'/front/leave/types' , {
                    
                }).then(function(response){
                    
                    this.leavetypes = response.data;                    
                }.bind(this));
            },

            resetFlter : function()
            {                
                this.day_one = '';
                this.day_two = '';
                
                this.search_by_id.day_one = '';
                this.search_by_id.day_two = '';
                this.search_by_id.department_id = 0;
                this.search_by_id.jobposition_id = 0; 
                this.search_by_id.leave_type_id = 0;
                this.search_by_id.flg_status = -1;
                this.getLeaves();
                this.$root.$emit('bv::toggle::collapse', 'sidebar_right');
            },
            setFlter : function()
            {                
                this.search_by_id.day_one = this.day_one;
                this.search_by_id.day_two = this.day_two;
                this.getLeaves();
                this.$root.$emit('bv::toggle::collapse', 'sidebar_right');
            }

            
            
            
            

        },
        created: function(){
            
            this.getDepertments();
            this.getLeaveTypes();
            this.resetFlter();
            //this.getEmployeeLeaveSettings();
            this.getDisabledDates();
            //this.getApprovePendingLeavesToday();
            //Fire.$on('reloadUsers', () => {this.getLeaves()});
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.leaves;
                if (this.search) 
                {
                  
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            else if (this.columns[index].type && this.columns[index].type === 'number') 
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            fetchStartWeekday()
            {
                return this.week_start_day;
            },
        }
    }
</script>
<style scoped>
.img-holder
{
    cursor:not-allowed;
     pointer-events: none;
}
</style>
